import { schema } from 'normalizr'

const productsResponseSchema = { products: [new schema.Entity('products')] }

export { productsResponseSchema }
